import { cn } from "@repo/ui/lib/utils";
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from "react-router";
import LanguageSwitcher from "~/components/language-switcher";
import SectionChild from "~/components/SectionChild";
import { Icon } from "~/components/ui/icon";
import { menu_header, MenuItem } from '~/data/headerNavLinks';



function Logo() {
  return <Icon name="logo-main" className="w-[166px] h-[48px]" />;
}
const MobileNavLink = ({
  item,
  onToggleNav,
}: {
  item: MenuItem;
  onToggleNav: () => void;
}) => {
  const [navShow, setNavShow] = useState(false);
  return (
    <li className="border-b border-[#0000000F] py-4 pl-6 pr-2">
      <div className="flex items-center justify-between ">
        <Link
          to={item.href}
          className="text-xl tracking-widest text-gray-900 uppercase"
          onClick={onToggleNav}
        >
          {item.title}
        </Link>
        <svg
          width="12"
          height="8"
          viewBox="0 0 6 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => setNavShow(!navShow)}
          className="cursor-pointer"
        >
          <path
            d="M2.99992 3.33332L0.333252 0.666656H5.66659L2.99992 3.33332Z"
            fill="black"
            fillOpacity="0.6"
          ></path>
        </svg>
      </div>

      <ul className={cn("pl-4", !navShow && "hidden")}>
        {item.child &&
          item.child.map((i) => {
            return (
              <li key={i.title} className="mt-6">
                <Link
                  to={i.href}
                  className="flex items-center justify-between tracking-widest text-gray-900"
                  onClick={onToggleNav}
                >
                  {i.title}
                </Link>
              </li>
            );
          })}
      </ul>
    </li>
  );
};
function MobileNav({ navbar }: any) {
  const [navShow, setNavShow] = useState(false);

  const onToggleNav = () => {
    setNavShow((status) => {
      if (status) {
        document.body.style.overflow = "auto";
      } else {
        // Prevent scrolling
        document.body.style.overflow = "hidden";
      }
      return !status;
    });
  };
  return (
    <div className="place-content-center ">
      {navShow && (
        <div
          className="opacity_body"
          onClick={onToggleNav}
          aria-hidden="true"
        ></div>
      )}
      {!navShow && (
        <button
          aria-label="Toggle Menu"
          onClick={onToggleNav}
          className="lg:hidden"
        >
          <Icon name="menu" size="lg" />
        </button>
      )}

      <div
        className={`fixed right-0 top-0 z-50 h-full w-full max-w-[240px] transform bg-white opacity-95 duration-300 ease-in-out ${
          navShow ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-end border-b border-[#0000000F]">
          <button
            className="w-8 h-8 mt-4 mr-6"
            aria-label="Toggle Menu"
            onClick={onToggleNav}
          >
            <Icon name="menu" size="lg" />
          </button>
        </div>
        <nav className="fixed z-[999] h-full w-full">
          <ul className="">
            {navbar.map((link: any) => {
              return link.child ? (
                <MobileNavLink
                  item={link}
                  key={link.title}
                  onToggleNav={onToggleNav}
                />
              ) : (
                <li
                  key={link.title}
                  className="border-b border-[#0000000F] py-4 pl-6"
                >
                  <Link
                    to={link.href}
                    className="text-xl tracking-widest text-gray-900 uppercase"
                    onClick={onToggleNav}
                  >
                    {link.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
}

function Header() {
  const { t } = useTranslation();
  const navbar = menu_header.map((item)=>{
    return {
      ...item,
      title: t(item.title),
    };
  });
  return (
    <header className="bg-white">
      <SectionChild className="py-3">
        <nav className="flex justify-between">
          <div>
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div className="justify-end flex-1 hidden lg:flex">
            <div className="flex items-center gap-8 font-sans ">
              <ul className="flex items-center gap-5">
                {navbar.map((link) => (
                  <li key={link.title}>
                    <NavLink
                      to={link.href}
                      className={({ isActive }) =>
                        cn(
                          "text-[12px] xl:text-sm font-semibold uppercase",
                          isActive ? "menu-active" : "text-gray-900"
                        )
                      }
                    >
                      {link.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
              <LanguageSwitcher />
            </div>
          </div>
          <MobileNav navbar={navbar} />
        </nav>
      </SectionChild>
    </header>
  );
}
export default Header;
